import { Box } from '@mui/material'
import Header from 'components/Header'
import ListNavigation from 'components/ListNavigation'
import { operationOptions, companies } from 'constant'
import { OrderContext } from 'contexts/OrderContextProvider'
import { useContext, useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { isObjectNotEmpty } from 'utils'

const ChooseOperation = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { company } = useParams()
  const { setOrderContents, orderContents } = useContext(OrderContext)
  useEffect(() => {
    if (isObjectNotEmpty(orderContents)) setOrderContents({})
  }, [])
  useEffect(() => {
    if (!companies.some(company => pathname.includes(company))) {
      navigate('/', { replace: true })
    }
  }, [pathname])

  return (
    <Box>
      <Header buttonLink='/' />
      <ListNavigation elements={operationOptions} company={company!} />
    </Box>
  )
}

export default ChooseOperation
